.field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.input {
  min-height: 44px;
  padding: 0 10px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 14px;
  font-weight: 700;
}
